import { closeModal, showModal } from './modal'

export function isActionArticleInCart () {
  const basket = document.querySelector('.cart-icon__badge')
  return basket && basket.dataset.actionTicket === '1'
}

const showModalAndSetFocus = function (popup) {
  showModal(popup)
  const popupAutofocus = popup.querySelector('[data-js-first-focus]')
  if (!popupAutofocus) return
  popupAutofocus.focus()
}

export function checkModalSupport (popup) {
  return !(!popup || typeof popup.close !== 'function' || typeof popup.showModal !== 'function')
}

export function showModalOnExitIntent (popup, checkCallback = function () {}) {
  const exit = function (event) {
    const shouldExit =
            event.target === popup // user clicks on backdrop of the dialog

    if (shouldExit) {
      closeModal(popup)
    }
  }

  const mouseEvent = function (event) {
    const shouldShowExitIntent =
            !event.toElement &&
            !event.relatedTarget &&
            event.clientY < 10

    if (shouldShowExitIntent) {
      document.removeEventListener('mouseout', mouseEvent)
      if (checkCallback() === false) {
        return
      }
      showModalAndSetFocus(popup)
    }
  }

  setTimeout(() => {
    document.addEventListener('mouseout', mouseEvent)
    popup.addEventListener('click', exit)
  }, 2000)

  // browser back button handling
  window.addEventListener('popstate', function () {
    showModalAndSetFocus(popup)
  })

  // handle visibility change
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      setTimeout(function () {
        if (document.hidden) {
          if (checkCallback() === false) {
            return
          }
          showModalAndSetFocus(popup)
        }
      }, 1000)
    }
  })

  // ensure that popstate can be used
  history.pushState(null, null, window.location.href)
}

export function showModalAfterCartInactivity (popup, delay = 20000, checkCallback = function () {}) {
  let timer

  const resetTimer = (event) => {
    if (event.target.closest('[data-js-add-to-cart]')) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        showModalAndSetFocus(popup)
        document.removeEventListener('click', resetTimer, true)
      }, delay)
    }
  }

  document.addEventListener('click', resetTimer, true)

  timer = setTimeout(() => {
    if (checkCallback() === false) {
      return
    }
    showModalAndSetFocus(popup)
    document.removeEventListener('click', resetTimer, true)
  }, delay)
}
